import { render, staticRenderFns } from "./player_averageOccupancy_scatter.vue?vue&type=template&id=22a4934b&scoped=true"
import script from "./player_averageOccupancy_scatter.vue?vue&type=script&lang=js"
export * from "./player_averageOccupancy_scatter.vue?vue&type=script&lang=js"
import style0 from "./player_averageOccupancy_scatter.vue?vue&type=style&index=0&id=22a4934b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a4934b",
  null
  
)

export default component.exports